export interface AnswerEntry {
  entryId: number;
  entryType: AnswerEntryType;
  key: string;
  value: string | number;
}

export enum AnswerEntryType {
  Unit = 'unit',
  Option = 'option',
  Troop = 'troop',
}
